export default [
    {
      path: '/charts',
      name: 'charts',
      component: () => import('../../views/charts/charts.vue'),
      meta: {
        pageTitle: 'Charts',
        breadcrumbs: ['Playlists', 'Charts'],
      },
      children:[
        {
          path: '',
          name: 'charts-list',
          component: () => import('../../views/charts/list.vue')
        },
        {
          path: 'create',
          name: 'charts-create',
          component: () => import('../../views/charts/create.vue'),
          meta: {
            pageTitle: 'Create Charts',
            breadcrumbs: ['Charts', 'Create'],
          }
        },
        {
          path: ':id/edit',
          name: 'charts-edit',
          component: () => import('../../views/charts/edit.vue'),
          meta: {
            pageTitle: 'Edit charts',
            breadcrumbs: ['Charts', 'Edit'],
          }
        }
      ]
    }
]
  